import "./App.scss";
import {
  Navigate,
  RouterProvider,
  createBrowserRouter,
} from "react-router-dom";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";


import Login from "./pages/login";
import Workbench from "./pages/workbench";
import Dashboard from "./pages/dashboard/Dashboard";
import VerifyLogin from "./pages/verifyMagicLink";
import PublicRoutesCheck from "./utilities/Routes/PublicRoutes";
import PrivateRoutesCheck from "./utilities/Routes/PrivateRoutes";
import Loader from "./components/Loader/Loader";
import { ROUTES } from "./utilities/Constants/Constants";
import ListQuery from "./pages/ListQuery";
import SemanticModel from "./pages/SemanticModel";
import SemanticModelLayout from "./components/Layout/SemanticModelLayout";
import Pinboard from "./pages/Pinboard";
import ViewModels from "./pages/modelsCard";

const App = () => {
  const routes = [
    {
      path: "",
      element: (
        <>
          {/* <Navigate to={ROUTES.MANAGE_SCHOOLS} /> */}
          <Navigate to={ROUTES.DASHBOARD} />
        </>
      ),
    },
    {
      path: "",
      element: <PublicRoutesCheck />,
      children: [
        {
          path: ROUTES.LOGIN,
          element: <Login />,
        },
        {
          path: ROUTES.VERIFY_LOGIN,
          element: <VerifyLogin />,
        },
      ],
    },
    {
      path: "",
      element: <PrivateRoutesCheck />,
      children: [
        {
          path: ROUTES.WORK_BENCH,
          element: <Workbench />,
        },
        {
          path: ROUTES.DASHBOARD,
          name: "dashboard",
          element: <Dashboard />,
        },
         {
          path: ROUTES.QUERYLIST,
          name: "copilot",
          element: <ListQuery />,
        },
         {
          path: ROUTES.VIEWMODELS,
          name: "viewModels",
          element: <ViewModels />,
        },
      ],
    },
    {
      path: "/",
      element: (
        <SemanticModelLayout>
          <PrivateRoutesCheck />
        </SemanticModelLayout>
      ),
      children: [
        {
          path: ROUTES.SEMANTIC_MODEL,
          name: "semanticModel",
          element: <SemanticModel />
        }
      ],
    },
    {
      path: ROUTES.PINBOARD,
      element: (
          <SemanticModelLayout config={{isTitleEditable: false}}>
            <PrivateRoutesCheck />
          </SemanticModelLayout>
      ),
      children: [
        {
          path: ":sk",
          name: "pinboardDetail",
          element: <Pinboard />,
        },
      ],
    },
    {
      path: "*",
      element: (
        <>
          {/* <Navigate to={ROUTES.MANAGE_SCHOOLS} /> */}
          <Navigate to={ROUTES.DASHBOARD} />
        </>
      ),
    },
  ];

  const routers = createBrowserRouter(routes);

  return (
    <>
      <div>
        <Loader></Loader>
        <RouterProvider router={routers} />
        <ToastContainer />
      </div>
    </>
  );
};

export default App;
